import React from 'react';
import {
	EntityError,
	translateLogicErrorCodeShort,
	translateLogicErrorCodeWithEntityName,
} from '@elyx-code/project-logic-tree';
import './entity-error.css';
import { resolveSeverityIcon } from '../notifications/NotificationsPanel';
import { NotificationSeverity } from '../../services/notifications';
import { readableTimeFromNow } from '../../utils/date';

export interface IEntityErrorListItemProps {
	error: EntityError;
	onClick: (error: EntityError) => void;
}

export default function EntityErrorListItem(props: IEntityErrorListItemProps) {
	return (
		<li key={props.error.id} className='entity-error__results__item'>
			<button
				className='entity-error__results__item-button'
				onClick={() => {
					props.onClick(props.error);
				}}
			>
				<i
					className={`fa-solid ${resolveSeverityIcon(
						props.error.severity as any as NotificationSeverity
					)}`}
				/>
				<span className='entity-error__results__item__body'>
					<span className='entity-error__results__item__header-line'>
						<p className='entity-error__results__item__title'>
							{translateLogicErrorCodeShort(props.error)}
						</p>
						<p className='entity-error__results__item__time'>
							{readableTimeFromNow(new Date())}
						</p>
					</span>
					<p className='entity-error__results__item__description'>
						{translateLogicErrorCodeWithEntityName(props.error)}
					</p>
				</span>
			</button>
		</li>
	);
}
